import { useDSToast } from '@stihl-design-system/components';
import { ToastOptions } from '@stihl-design-system/components/components/Toast/Toast.utils';

export const useToolShedToast = () => {
  const { queueDSToastMessage } = useDSToast();

  const toastForVariant = (variant: ToastOptions['variant']) => (message: string, options?: ToastOptions) =>
    queueDSToastMessage(message, {
      ...options,
      'data-testId': `${variant}-message`,
      variant,
    });

  return {
    showSuccessToast: toastForVariant('success'),
    showWarningToast: toastForVariant('warning'),
    showInfoToast: toastForVariant('info'),
  };
};
